<template>
  <section class="pc-grid-section" aria-labelledby="pc-grid-heading-power">
    <h2 id="pc-grid-heading-power" class="pc-grid-title">
      {{ sectionTitle }}
    </h2>
    <div class="pc-grid-outer">
      <div class="pc-grid">
        <article
          v-for="(p, idx) in gridItems"
          :key="'grid-' + p.id + '-' + idx"
          class="pc-card"
        >
          <div class="pc-card-bg" :style="cardStyle(idx)" aria-hidden="true"></div>
          <div class="pc-card-meta">
          <img :src="require('@/assets/line.png')" alt="" class="pc-card-icon">
            <div class="pc-card-name" v-html="p.name"></div>
        
          </div>
        </article>
      </div>
    </div>
  </section>
</template>

<script>


const BANK_BG = [
  require('@/assets/bank1.png'),
  require('@/assets/bank2.png'),
  require('@/assets/bank3.png'),
  require('@/assets/bank4.png'),
  require('@/assets/bank5.png'),
  require('@/assets/bank6.png'),
  require('@/assets/bank7.png'),
  require('@/assets/bank8.png'),
  require('@/assets/bank9.png'),
]

export default {
  name: 'ProductCenterGrid',
  data() {
    return {
      gridItems: [
        {
          id: 'power1',
          name: this.$t('productName.power1'),
        },
        {
          id: 'power2',
          name: this.$t('productName.power2'),
        },
        {
          id: 'power3',
          name: this.$t('productName.power3'),
        },
        {
          id: 'power4',
          name: this.$t('productName.power4'),
        },
        {
          id: 'power5',
          name: this.$t('productName.power5'),
        },
        {
          id: 'power6',
          name: this.$t('productName.power6'),
        },
        {
          id: 'power7',
          name: this.$t('productName.power7'),
        },
        {
          id: 'power8',
          name: this.$t('productName.power8'),
        },
        {
          id: 'power9',
          name: this.$t('productName.power9'),
        },
      ],
    }
  },
  computed: {
    sectionTitle() {
      return this.$t('productCenter.titles.power')
    },
 
  },
  methods: {
    cardStyle(idx) {
      const url = BANK_BG[idx] || BANK_BG[0]
      return {
        backgroundImage: `url(${url})`,
      }
    },
  },
}
</script>

<style scoped>
    .pc-card-icon{
        width: 100%;
        max-width: 426px;
    }
.pc-grid-section {
  background:#EDEDED;
  padding: 48px 24px 72px;
  box-sizing: border-box;
}

.pc-grid-title {
  margin: 40px 0 70px 0;
  font-family: LINESeedJP_TTF, LINESeedJP_TTF;
  font-weight: bold;
  font-size: 38px;
  color: #282828;
  line-height: 33px;
  text-align: center;
  font-style: normal;
  text-transform: none;
}

.pc-grid-outer {
  width: 100%;
  max-width: 1570px;
  margin: 0 auto;
  box-sizing: border-box;
}

.pc-grid {
  display: grid;
  grid-template-columns: repeat(3, 504px);
  gap: 29px;
  justify-content: center;
  width: 100%;
  max-width: 1570px;
  margin: 0 auto;
  box-sizing: border-box;
}

.pc-card {
  position: relative;
  width: 504px;
  height: 504px;
  max-width: 100%;
  box-sizing: border-box;
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.06);
  overflow: hidden;
  background-color: #e8e8e8;
}

.pc-card-bg {
  position: absolute;
  inset: 0;
  z-index: 0;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  transition: transform 0.45s ease;
  will-change: transform;
}

.pc-card:hover .pc-card-bg {
  transform: scale(1.06);
}

.pc-card-meta {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  padding: 20px 20px 22px 41px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
  gap: 14px;
  z-index: 1;
}

.pc-card-name {
  font-family: LINESeedJP_TTF, LINESeedJP_TTF;
  font-weight: bold;
  font-size: 22px;
  color: #454545;
  line-height: normal;
  margin-top: 15px;
  text-align: left;
  font-style: normal;
  text-transform: none;

}

.pc-card-cta {
  display: inline-flex;
  align-items: center;
  gap: 35px;
  padding: 5px 10px 5px 10px;
  background: #2563eb;
font-weight: 300;
font-size: 21px;
color: #FFFFFF;
line-height: 23px;
text-align: left;
font-style: normal;
text-transform: none;
  text-decoration: none;
  border-radius: 0;
  transition: background 0.2s ease;
}

.pc-card-cta:hover {
  background: #1d4ed8;
}

.pc-card-cta-arrow{
  width: 28px;
  height: 20px;
}
@media (max-width: 1600px) {
  .pc-grid {
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 20px;
  }

  .pc-card {
    width: 100%;
    height: auto;
    aspect-ratio: 1;
  }
}

@media (max-width: 1024px) {
  .pc-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 560px) {
  .pc-grid-section {
    padding: 32px 16px 48px;
  }

  .pc-grid {
    grid-template-columns: 1fr;
  }
}
</style>
